import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { InvoiceStatus } from '../enums';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class InvoiceStatusProviderService {
  private readonly entries = new Map<InvoiceStatus, string>([
    [InvoiceStatus.New, 'Oczekująca na wygenerowanie'],
    [InvoiceStatus.Failed, 'Błąd generowania'],
    [InvoiceStatus.Generated, 'Wygenerowana'],
  ]);

  public labelFor(status: InvoiceStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<InvoiceStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem<InvoiceStatus>(label, status),
      ),
    );
  }
}
